import { Injectable } from '@angular/core';
import {environment} from "@environments/environment";

export enum DEBUG {
  LOGIN = 'Login',
  AUTH = 'Auth',
  LIVE_ASSISTANCE = 'Live assistance',
  VIDEOCALL = 'Videocall',
  VIDEOCALL_UNITY_MODULE = 'Videocall Unity Module',
  VIDEOCALL_BABYLON_MODULE = 'Videocall Babylon Module',
  AUTHORING = 'Authoring',
  FIELD_SERVICE = 'Field service',
  TRACKING = 'Tracking',
}

@Injectable({
  providedIn: 'root'
})
export class DebugService {

  debugEnabled = !environment.production;

  colors = {
    bg: '#222',
    error: 'red',
    warn: 'orange',
    success: '#bada55',
  };

  constructor() {
    // TODO override debugEnabled forcing to true
    this.debugEnabled = true;
  }

  log(debugComponent: DEBUG, message: any, data?: any) {
    if (this.debugEnabled) {
      const _data = data ? [message, data] : [message];
      console.log(`%c[${debugComponent}]`, `background: ${this.colors.bg}; color: ${this.colors.success}; font-weight: bold`, ..._data);
    }
  }

  warning(debugComponent: DEBUG, message: any, data?: any) {
    if (this.debugEnabled) {
      const _data = data ? [message, data] : [message];
      console.warn(`%c[${debugComponent}]`, `background: ${this.colors.bg}; color: ${this.colors.warn}; font-weight: bold`, ..._data);
    }
  }

  error(debugComponent: DEBUG, message: any, data?: any) {
    const _data = data ? [message, data] : [message];
    console.error(`%c[${debugComponent}]`, `background: ${this.colors.bg}; color: ${this.colors.error}; font-weight: bold`, ..._data);
  }

}
